(function($) {

    const accordions = {};
    let lastAccordionId = 1;
    let initialized = false;

    $.fn.c24Accordion = function() {
        const items = $(this);
        items.each(function() {

            const accordionElement = $(this);

            if (accordionElement.data('c24Accordion-id')) {
                return;
            }

            const id = lastAccordionId++;
            accordions[id] = new C24Accordion(id, accordionElement);
        });

        if (!initialized) {
            initialized = true;
            openAccordionItemByLinkHash(window.location.hash);
        }
    };
    class C24Accordion {
        constructor(id, accordion) {
            this.id = id;

            this.accordion = accordion;
            this.accordion.data('c24Accordion-id', this.id);

            this.settings = this.getSettings();

            this.addFullWidthClassForLastChildInContent();

            if (this.settings.allopen) {
                this.openAllItems();
            } else {
                this.openDefaultOpenItems();
            }

            const self = this;
            this.accordion.on('click', this.settings.selectors.header, function() {
                const item = self.getItemFromHeader($(this));
                self.toggleItem(item);
            });
        }

        getSettings() {
            const settings = {
                speed: 200,
                /*
                 * Supported modes:
                 *
                 * - siblings:
                 *     accordion
                 *     |--item-1 = header-1
                 *     |--content-1
                 *     |--item-2 = header-2
                 *     |--content-2
                 *     ...
                 *
                 * - children:
                 *     accordion
                 *     |--item-1 = header-1
                 *        ..
                 *        |--content-1
                 *     |--item-2 = header-2
                 *        ..
                 *        |--content-2
                 *     ...
                 *
                 * - list:
                 *     accordion
                 *     |--item-1
                 *        |--header-1
                 *        |--content-1
                 *     |--item-2
                 *        |--header-2
                 *        |--content-2
                 *     ...
                 */
                mode: undefined,
                selectors: {
                    item: undefined,
                    header: undefined,
                    content: undefined,
                },
                classes: {
                    open: 'c24Open',
                },
                scrollOnOpen: window.c24LpIsMobile,
                allopen: false,
            };

            if (this.accordion.hasClass('shadow') || this.accordion.hasClass('collapsed')) {
                settings.mode = 'list';

                settings.selectors.item = 'li';
                settings.selectors.header = 'h3';
                settings.selectors.content = 'div';
            } else {
                const useChildren = this.accordion.data('usechildren');
                settings.mode = useChildren ? 'children' : 'siblings';

                settings.selectors.item = '.c24Header';
                settings.selectors.header = '.c24Header';
                settings.selectors.content = '.c24Content';
            }

            if (this.accordion.data('noscroll') ) {
                settings.scrollOnOpen = false;
            }

            return settings;
        }

        openAllItems() {

            const items = this.getAllItems();

            if (this.settings.mode === 'siblings') {
                items.next(this.settings.selectors.content).show();

            } else if (this.settings.mode === 'children') {
                items.children(this.settings.selectors.content).show();

            } else if (this.settings.mode === 'list') {
                items.children(this.settings.selectors.content).show();

            } else {
                console.log('accordion error: unknown mode', this.settings.mode);
            }

            items.addClass(this.settings.classes.open);
        }

        openDefaultOpenItems() {

            const openItems = this.getAllOpenItems();
            const closedItems = this.getAllClosedItems();


            if (this.settings.mode === 'siblings') {
                closedItems.next(this.settings.selectors.content).hide();
                openItems.next(this.settings.selectors.content).show();

            } else if (this.settings.mode === 'children') {
                closedItems.children(this.settings.selectors.content).hide();
                openItems.children(this.settings.selectors.content).show();

            } else if (this.settings.mode === 'list') {
                closedItems.children(this.settings.selectors.content).hide();
                openItems.children(this.settings.selectors.content).show();

            } else {
                console.log('accordion error: unknown mode', this.settings.mode);
            }
        }

        toggleItem(item) {
            const content = this.getContentFromItem(item);

            if (content.is(':visible')) {
                this.closeItem(item);
            } else {
                this.openItem(item);
            }
        }

        openItem(item) {
            const content = this.getContentFromItem(item);

            if (content.is(':visible')) {
                return;
            }

            const header = this.getHeaderFromItem(item);
            const openItems = this.getAllOpenItems().not(item);

            if (this.settings.scrollOnOpen) {

                item.addClass(this.settings.classes.open);

                content.stop().slideDown(this.settings.speed, () => {

                    console.log('accordion| scroll to not overlap 1', {
                        scrollTop: Math.round(header.offset().top - this.scrollTopOffset()),
                    });

                    $('html').animate({
                        scrollTop: Math.round(header.offset().top - this.scrollTopOffset()),
                    }, 500, 'swing', () => {

                        if (openItems.length) {
                            const self = this;
                            openItems.each(function() {
                                self.closeItem($(this), true);
                            });
                        }

                        console.log('accordion| scroll to not overlap 2', {
                            scrollTop: Math.round(header.offset().top - this.scrollTopOffset()),
                        });

                        $(window).scrollTop(header.offset().top - this.scrollTopOffset());
                    });
                });
            } else {
                if (openItems.length) {
                    const self = this;
                    openItems.each(function() {
                        self.closeItem($(this), false);
                    });
                }

                item.addClass(this.settings.classes.open);

                content.stop().slideDown(this.settings.speed, () => {

                    const topOffset = header.offset().top - this.scrollTopOffset();
                    const windowHeight = $(window).height();
                    const windowScrollTop = $(window).scrollTop();

                    if (topOffset < windowScrollTop || topOffset > (windowScrollTop + windowHeight)) {

                        console.log('accordion| scroll to not overlap 3', {
                            scrollTop: topOffset,
                        });

                        $(window).scrollTop(topOffset);
                    }
                });
            }
        }

        scrollTopOffset() {
            return window.c24FixableScrollTopOffset || 0;
        }

        scrollToItem(item) {
            const header = this.getHeaderFromItem(item);
            $(window).scrollTop(header.offset().top - this.scrollTopOffset());

        }

        closeItem(item, hide) {
            const content = this.getContentFromItem(item);

            if (!content.is(':visible')) {
                return;
            }

            if (hide) {
                content.stop().hide();
                item.removeClass(this.settings.classes.open);
            } else {
                content.stop().slideUp(this.settings.speed, () => {
                    item.removeClass(this.settings.classes.open);
                });
            }
        }

        getAllItems() {
            return this.accordion.children(this.settings.selectors.item);
        }

        getAllOpenItems() {
            return this.accordion.children(this.settings.selectors.item + '.' + this.settings.classes.open);
        }

        getAllClosedItems() {
            return this.accordion.children(this.settings.selectors.item + ':not(.' + this.settings.classes.open + ')');
        }

        getItemFromHeader(header) {
            if (this.settings.mode === 'siblings') {
                return header;
            }

            if (this.settings.mode === 'children') {
                return header;
            }

            if (this.settings.mode === 'list') {
                return header.parent();
            }

            console.log('accordion error: unknown mode', this.settings.mode);
            return undefined;
        }

        getHeaderFromItem(item) {

            if (this.settings.mode === 'siblings') {
                return item;
            }

            if (this.settings.mode === 'children') {
                return item;
            }

            if (this.settings.mode === 'list') {
                return item.children(this.settings.selectors.header);
            }

            console.log('accordion error: unknown mode', this.settings.mode);
            return undefined;
        }

        getContentFromItem(item) {

            if (this.settings.mode === 'siblings') {
                return item.next(this.settings.selectors.content);
            }

            if (this.settings.mode === 'children') {
                return item.children(this.settings.selectors.content);
            }

            if (this.settings.mode === 'list') {
                return item.children(this.settings.selectors.content);
            }

            console.log('accordion error: unknown mode', this.settings.mode);
            return undefined;
        }

        getItemFromElement(element) {
            const allItems = this.getAllItems();

            const self = this;
            const matchedItem = allItems.filter(function() {
                const item = $(this);

                if (item.find(element).length) {
                    return true;
                }

                if (self.settings.mode === 'siblings') {
                    const content = self.getContentFromItem(item);
                    if (content.find(element).length) {
                        return true;
                    }
                }

                return false;
            });

            return matchedItem;
        }

        addFullWidthClassForLastChildInContent() {

            const items = this.getAllItems();

            const self = this;
            items.each(function() {
                const item = $(this);
                const content = self.getContentFromItem(item);

                const lastChildInContent = content.children(':last-child');
                if (lastChildInContent.length && lastChildInContent.is('.c24ContentBox')) {
                    item.addClass('fullWidthBorder');
                }
            });
        }
    }

    function openAccordionItemByLinkHash(hash) {

        if (!hash) {
            return;
        }

        const result = getAccordionItemByLinkHash(hash);
        if (!result) {
            return;
        }

        result.accordion.openItem(result.item);
    }

    function getAccordionItemByLinkHash(hash) {
        const urlId = hash.replace('#', '');
        const urlElement = urlId ? $(`#${urlId}`) : null;
        if (!urlElement || !urlElement.length) {
            return undefined;
        }

        const accordion = getAccordionWithElement(urlElement);
        if (!accordion) {
            return undefined;
        }

        const item = accordion.getItemFromElement(urlElement);
        if (!item) {
            return undefined;
        }

        return {
            accordion,
            item,
        };
    }

    function getAccordionWithElement(element) {
        const accordionElement = element.closest('.c24Accordion, .mod24Accordion');
        if (!accordionElement.length) {
            return undefined;
        }

        const accordionId = accordionElement.data('c24Accordion-id');
        if (!accordionId) {
            return undefined;
        }

        const accordion = accordions[accordionId];
        if (!accordion) {
            return undefined;
        }

        return accordion;
    }

    $(document).ready(function() {
        $('a[href*="#"], area[href*="#"]').on('click',function (e) {
            if (e.ctrlKey) {
                return;
            }

            const href = $(this).attr('href');
            const link = new URL(href, window.location.protocol + '//' + window.location.host);

            const linksToThisPage = href.indexOf('#') === 0 || link.pathname === window.location.pathname;
            if (!linksToThisPage) {
                return;
            }

            openAccordionItemByLinkHash(link.hash);
        });
    });
})(window.jQuery);
